import moment from "moment";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { SET_SELECTED_CAMPAIGN_ID } from "../../src/components/MainContent/SMP/Settings/Campaign/CampaignActions";
const schedulePostForm = {
    scheduledTime: null,
    postContent: "",
    selectedAssets: [],
    assetTypeSelected: null,
    itemEditing: null,
};

const initialstate = {
    smpPageList: {},
    smpPageListLoading: false,
    smpPageListError: null,

    smpPostList: [],
    smpPostListLoading: false,
    smpPostListError: null,

    selectedPageOption: ["selectAll"],
    filterUpdated: 0,

    assetsList: [],
    assetsObj: {},
    stablizedItemsIds: {},
    assetsListLoading: false,
    folderList: [],
    folderListLoading: false,
    smpPublishedList: [],
    totalPublishedCount: 0,
    publishedOffset: 1,
    campaignList: {},

    ...schedulePostForm,
};

const platformIdList = (val) => {
    let res = [];
    val?.map((ele) => res.push(ele.page_id));
    return res;
};

const getPublishedData = (data) => {
    let postList = [];
    let posts = {};
    data.forEach((ele) => {
        posts["content"] = ele._source.post.content;
        posts["engagement"] = ele._source.post.engagement_values;
        posts["publishedDate"] = ele._source.post.published_date;
        posts["platform"] = ele._source.platforms;
        posts["url"] = ele._source.post.url;
        posts["media"] = ele._source.post.media;
        posts["pageIds"] = ele._source.post.page_id;

        postList.push(posts);
    });

    return data;
};

const SMPReducer = (state = initialstate, action) => {
    switch (action.type) {
        case isPending("FETCH_SMP_PAGES_LIST"):
            return (state = {
                ...state,
                smpPageListLoading: true,
                smpPageList: {},
            });
        case isRejected("FETCH_SMP_PAGES_LIST"):
            return (state = {
                ...state,
                smpPageListLoading: false,
                smpPageList: {},
            });

        case isFulfilled("FETCH_SMP_PAGES_LIST"): {
            let smpPageList = {};
            action.payload.data?.tokens
                ?.filter((p) => p.features.includes("smp") && ["facebook", "instagram", "twitter", "linkedin"].includes(p.platform))
                .forEach((p) => {
                    smpPageList[p.page_id] = p;
                });

            return (state = {
                ...state,
                smpPageListLoading: false,
                smpPageList: smpPageList,
            });
        }

        case isFulfilled("FETCH_PUBLISHED_POSTS"): {
            // let smpPublishedList = {};
            // action.payload.data?.tokens
            //     ?.filter((p) => p.features.includes("smp") && ["facebook", "instagram", "twitter"].includes(p.platform))
            //     .forEach((p) => {
            //         smpPageList[p.page_id] = p;

            //     });
            return (state = {
                ...state,
                // smpPageListLoading: false,
                smpPublishedList: action.payload?.hits?.hits || [],
                totalPublishedCount: action.payload?.hits?.total,
                publishedOffset: action.payload?.offset,
            });
        }

        case "SET_SELECTED_PAGES_SMP":
            return (state = {
                ...state,
                selectedPageOption: action.payload,
                filterUpdated: state.filterUpdated + 1,
            });
        case isFulfilled("GET_SMP_ASSETS_LIST"): {
            let assetsList = { ungrouped: { name: "", type: "ungrouped", assets: [] } };
            let assetsObj = {};

            action.payload.data?.assets?.forEach((asset) => {
                let a = { ...asset, metadata: JSON.parse(asset.metadata) };
                assetsObj[asset.id] = a;
                let folder_name = asset.folder_name || "ungrouped";

                if (assetsList[folder_name]) {
                    assetsList[folder_name].assets.push(a);
                } else {
                    let val = 0;
                    val += a.metadata.size;

                    assetsList[folder_name] = { type: "folder", name: folder_name, assets: [a], created_at: a.created_at, size: val };
                }
            });

            let folderList = Object.keys(assetsList).filter((f) => f != "ungrouped");

            assetsList = Object.values(assetsList);

            return { ...state, assetsList, assetsListLoading: false, folderList, assetsObj };
        }
        case isFulfilled("UPDATE_SMP_ASSET"): {
            let { asset, params } = action.payload;
            let assetsList = JSON.parse(JSON.stringify(state.assetsList));

            let folder = assetsList.findIndex((f) => f.name === asset.folder_name);
            let assetIndex;
            if (folder >= 0) assetIndex = assetsList[folder].assets.findIndex((a) => a.id == asset.id);

            if (assetIndex >= 0) assetsList[folder].assets[assetIndex] = { ...assetsList[folder].assets[assetIndex], ...params };

            return { ...state, assetsList, assetsObj: { ...state.assetsObj, [asset.id]: { ...state.assetsObj[asset.id], ...params } } };
        }
        case isPending("GET_SMP_ASSETS_LIST"): {
            return { ...state, assetsListLoading: true };
        }
        case isFulfilled("GET_SMP_FOLDER_LIST"): {
            return { ...state, folderList: action.payload.folders, folderListLoading: false };
        }
        case isPending("GET_SMP_FOLDER_LIST"): {
            return { ...state, folderListLoading: true };
        }

        case isPending("GET_SCHEDULED_POSTS"):
            return (state = {
                ...state,
                smpPostListLoading: true,
                smpPostList: [],
            });
        case isRejected("GET_SCHEDULED_POSTS"):
            return (state = {
                ...state,
                smpPostListLoading: false,
                smpPostList: [],
            });
        case isFulfilled("GET_SCHEDULED_POSTS"): {
            let schedules = action.payload.data?.schedules?.map((s) => {
                return { ...s, publishing_payload: JSON.parse(s.publishing_payload), platformIds: platformIdList(s.platforms) };
            });

            // .sort((a, b) => {
            //     return -1 * moment(b.scheduled_at).isAfter(moment(a.scheduled_at));
            // });

            return (state = {
                ...state,
                smpPostListLoading: false,
                smpPostList: schedules,
            });
        }

        case "SET_SCHEDULED_TIME":
            return { ...state, scheduledTime: action.payload };
        case "SET_POST_CONTENT":
            return { ...state, postContent: action.payload };
        case "SET_SELECTED_ASSETS":
            return { ...state, selectedAssets: action.payload };
        case "SET_SELECTED_ASSETS_TYPE":
            return { ...state, assetTypeSelected: action.payload };
        case "SET_EDIT_ITEM":
            return {
                ...state,
                itemEditing: action.payload,
                selectedPageOption: action.payload.page_id ? [action.payload.page_id] : [action.payload],
                selectedCampaignId: action.payload.campaign_id ? action.payload.campaign_id : 0,
            };
        case "RESET_SCHEDULE_FORM":
            return { ...state, ...schedulePostForm };
        case "SMP_CLEANUP": {
            return initialstate;
        }
        case SET_SELECTED_CAMPAIGN_ID:
            return {
                ...state,
                selectedCampaignId: action.payload,
            };
        case isPending("RETRY_POST"):
            return (state = {
                ...state,
                smpPostListLoading: true,
                // smpPageList: {},
            });
        case isRejected("RETRY_POST"):
            return (state = {
                ...state,
                smpPostListLoading: false,
                // smpPageList: {},
            });
        case isFulfilled("RETRY_POST"): {
            // let smpPageList = {};
            // action.payload.data?.tokens
            //     ?.filter((p) => p.features.includes("smp") && ["facebook", "instagram", "twitter"].includes(p.platform))
            //     .forEach((p) => {
            //         smpPageList[p.page_id] = p;
            //     });

            return (state = {
                ...state,
                smpPostListLoading: false,
                // smpPageList: smpPageList,
            });
        }

        case isFulfilled("FETCH_CAMPAIGN_LIST"): {
            return (state = {
                ...state,
                campaignList: action.payload.data.campaigns,
            });
        }

        default:
            return state;
    }
};

export default SMPReducer;
